import { createDate, getDateFormatted } from "./TimeUtils";

export const StringRegex = {
    EMAIL: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/,
    LETTERSONLY: /^[a-z A-Z]*$/,
};

export const helperTextHandle = (errorType: string, name: string): string => {
    let text = "";

    switch (errorType) {
        case "required":
            text = `${name} is required`;
            break;
        case "pattern":
            text = `This is not a valid ${name}`;
            break;
        case "minLength":
            text = `${name} must be 8 characters`;
            break;
        case "validate":
            text = `The passwords are not the same`;
            break;
        default:
            return text;
    }
    return text;
};

export const validateDate = (value: string) => {
    const dayJsValue = value && value !== "Invalid Date" ? createDate(value) : undefined;
    const valueConvertedBack = dayJsValue ? getDateFormatted(dayJsValue) : undefined;
    const valueIsSame = value === valueConvertedBack;
    return !!dayJsValue && valueIsSame;
};
